import Policy from "./Policy";

export default function RegistrationPolicy() {
  return <Policy type="registration" />;
}
